import React from 'react';
import { getExternalLinkParameterForAdvancedSearch } from 'smartsuite-advanced-search-app';
import { AlertLevelCell, TableCell } from 'smartsuite-ui';
import FlightDetailLink from '../components/DetailLinks/FlightDetailLink';
import { getNonApiUri } from '../utils/getUri';
import AdvancedSearchLinkTableWrapper from './CustomWidgets/AdvancedSearchLinkTable/AdvancedSearchLinkTableWrapper';
import { buildQueryConfiguration } from './CustomWidgets/AdvancedSearchLinkTable/advancedSearchLinkUtils';
import GroupColumnTableWrapper from './CustomWidgets/GroupColumnTable/GroupColumnTableWrapper';
import renderCountLink from './renderCountLink';

async function buildAdvancedSearchExternalLinkParameter(
    timeAndPrecision,
    filterValues,
    whereClauses,
    dataRow,
    argumentConfigs,
    predicateLabels
) {
    const queryConfiguration = buildQueryConfiguration(
        timeAndPrecision,
        filterValues,
        whereClauses,
        dataRow,
        argumentConfigs,
        predicateLabels
    );
    const externalLinkParameter = await getExternalLinkParameterForAdvancedSearch(
        queryConfiguration
    );
    return externalLinkParameter;
}

export default {
    widgetRenderers: {
        advancedSearchLinkTable: {
            key: 'advancedSearchLinkTable',
            render: (widgetProps) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <AdvancedSearchLinkTableWrapper {...widgetProps} />
            ),
        },
        groupColumnTable: {
            key: 'groupColumnTable',
            render: (widgetProps) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <GroupColumnTableWrapper {...widgetProps} />
            ),
        }
    },
    buildAdvancedSearchExternalLinkParameter,
    supplementalTableCellRenderer: ({ columnConfig, resultRow }) => {
        if (columnConfig.renderType === 'flightLink') {
            return (
                <TableCell>
                    <FlightDetailLink
                        id={resultRow[columnConfig.idDataKey]}
                        hasAccess={resultRow[columnConfig.hasAccessDataKey]}
                    >
                        {resultRow[columnConfig.dataKey]}
                    </FlightDetailLink>
                </TableCell>
            );
        }

        if (columnConfig.renderType === 'colorCell') {
            return (
                <AlertLevelCell
                    alertLevelId={resultRow[columnConfig.stateDataKey]}
                >
                    {resultRow[columnConfig.dataKey]}
                </AlertLevelCell>
            );
        }

        const defaultCustomCellValue = '−';
        if (
            columnConfig.renderType === 'inboundToUnloadBagCargoCountStatusLink'
        ) {
            if (!resultRow[columnConfig.inboundExists]) {
                return <TableCell>{defaultCustomCellValue}</TableCell>;
            }

            const inboundLink = getNonApiUri(
                columnConfig.link.concat(resultRow[columnConfig.idDataKey])
            );

            return renderCountLink(
                resultRow[columnConfig.cargoPermission],
                resultRow[columnConfig.stateDataKey],
                resultRow[columnConfig.bagValueDataKey],
                resultRow[columnConfig.cargoValueDataKey],
                inboundLink,
                inboundLink,
                resultRow[columnConfig.hasAccessDataKey]
            );
        }

        const alertLevelNone = 0;
        if (columnConfig.renderType === 'inboundUnloadedBagCargoCountLink') {
            if (!resultRow[columnConfig.inboundExists]) {
                return <TableCell>{defaultCustomCellValue}</TableCell>;
            }

            const inboundLink = getNonApiUri(
                columnConfig.link.concat(resultRow[columnConfig.idDataKey])
            );

            return renderCountLink(
                resultRow[columnConfig.cargoPermission],
                alertLevelNone,
                resultRow[columnConfig.bagValueDataKey],
                resultRow[columnConfig.cargoValueDataKey],
                inboundLink,
                inboundLink,
                resultRow[columnConfig.hasAccessDataKey]
            );
        }

        if (
            columnConfig.renderType === 'outboundToLoadBagCargoCountStatusLink'
        ) {
            if (!resultRow[columnConfig.outboundExists]) {
                return <TableCell>{defaultCustomCellValue}</TableCell>;
            }

            const outboundBagLink = getNonApiUri(
                columnConfig.bagLink.concat(resultRow[columnConfig.idDataKey])
            );

            const outboundCargoLink = getNonApiUri(
                columnConfig.cargoLink.concat(resultRow[columnConfig.idDataKey])
            );

            return renderCountLink(
                resultRow[columnConfig.cargoPermission],
                resultRow[columnConfig.stateDataKey],
                resultRow[columnConfig.bagValueDataKey],
                resultRow[columnConfig.cargoValueDataKey],
                outboundBagLink,
                outboundCargoLink,
                resultRow[columnConfig.hasAccessDataKey]
            );
        }

        if (columnConfig.renderType === 'outboundLoadedBagCargoCountLink') {
            if (!resultRow[columnConfig.outboundExists]) {
                return <TableCell>{defaultCustomCellValue}</TableCell>;
            }

            const outboundBagLink = getNonApiUri(
                columnConfig.bagLink.concat(resultRow[columnConfig.idDataKey])
            );

            const outboundCargoLink = getNonApiUri(
                columnConfig.cargoLink.concat(resultRow[columnConfig.idDataKey])
            );

            return renderCountLink(
                resultRow[columnConfig.cargoPermission],
                alertLevelNone,
                resultRow[columnConfig.bagValueDataKey],
                resultRow[columnConfig.cargoValueDataKey],
                outboundBagLink,
                outboundCargoLink,
                resultRow[columnConfig.hasAccessDataKey]
            );
        }

        return undefined;
    },
};
